module.exports = __webpack_public_path__ + "img/Register-your-trademark.19dbf68b.jpg";